import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { API_URL } from "../../consts";

// Components
import CardItem from "../common/CardItem";
import CollectionCardMedia from "./CollectionCardMedia";
import CollectionCardHeader from "./CollectionCardHeader";
import CollectionCardBody from "./CollectionCardBody";

const CollectionItemCard = ({
  isBookmark,
  data,
  searhTags,
  applyMargin,
  onRateSuccessfully,
  displayStars,
  showRemove,
  onRemove,
  selected,
  isSelected,
  onSelect,
  enableDragAndDrop,
  currentSpaceId,
  onNavigate,
}) => {
  const dispatch = useDispatch();
  const authorized = useSelector((state) => state.authorized);

  // State
  const [isDragging, setIsDragging] = useState(false);

  // Handlers
  const handleCardClick = (e, cardData) => {
    if (!isDragging) {
      if (onNavigate) {
        onNavigate(`/spaces/${cardData.id}`);
      }
    }
  };

  const handleMenuAction = (action, data) => {
    if (action === 'viewCollection') {
      if (onNavigate) {
        onNavigate(`/spaces/${data.id}`);
      }
    }
  };

  // Drag and Drop handlers
  const handleDragStart = (e) => {
    if (!enableDragAndDrop) return;
    
    setIsDragging(true);
    e.dataTransfer.effectAllowed = "copy";
    
    // Store the collection data for the drop handler
    const dragData = {
      type: "collection",
      collection: {
        id: data.id,
        name: data.name,
        description: data.description,
        keywords: data.keywords || [],
        image: data.img_url || "",
        user_name: data.user_name,
        rates_count: data.rates_count,
        // Include all data needed
        fullData: data
      }
    };
    
    e.dataTransfer.setData("application/json", JSON.stringify(dragData));
    
    // Create a custom drag image
    const dragGhost = document.createElement("div");
    dragGhost.textContent = `📁 ${data.name || 'Collection'}`;
    dragGhost.style.position = "absolute";
    dragGhost.style.top = "-9999px";
    dragGhost.style.left = "-9999px";
    dragGhost.style.fontSize = "14px";
    dragGhost.style.fontWeight = "bold";
    dragGhost.style.padding = "8px 12px";
    dragGhost.style.borderRadius = "6px";
    dragGhost.style.backgroundColor = "#fff";
    dragGhost.style.border = "2px solid #6366f1";
    dragGhost.style.boxShadow = "0px 4px 12px rgba(99, 102, 241, 0.3)";
    dragGhost.style.color = "#6366f1";
    dragGhost.style.maxWidth = "300px";
    dragGhost.style.whiteSpace = "nowrap";
    dragGhost.style.overflow = "hidden";
    dragGhost.style.textOverflow = "ellipsis";

    document.body.appendChild(dragGhost);
    e.dataTransfer.setDragImage(dragGhost, 0, 0);

    setTimeout(() => {
      document.body.removeChild(dragGhost);
    }, 0);
  };

  const handleDragEnd = () => {
    setIsDragging(false);
  };

  return (
    <div
      draggable={enableDragAndDrop}
      onDragStart={handleDragStart}
      onDragEnd={handleDragEnd}
      style={{
        cursor: enableDragAndDrop ? 'grab' : 'default',
        opacity: isDragging ? 0.7 : 1,
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        width: '100%',
        height: '100%',
        transform: isDragging ? 'scale(1.02)' : 'scale(1)',
        filter: isDragging ? 'blur(1px)' : 'none',
      }}
    >
      <CardItem
        data={data}
        searhTags={searhTags}
        selected={selected}
        isSelected={isSelected}
        displayStars={displayStars}
        isBookmark={isBookmark}
        applyMargin={applyMargin}
        onRemove={onRemove}
        onRateSuccessfully={onRateSuccessfully}
        onSelect={onSelect}
        showRemove={showRemove}
        CustomMedia={CollectionCardMedia}
        CustomHeader={CollectionCardHeader}
        CustomBody={CollectionCardBody}
        onCardClick={handleCardClick}
        onMenuAction={handleMenuAction}
      />
    </div>
  );
};

CollectionItemCard.defaultProps = {
  displayStars: false, // Collections don't typically have stars
  displayStats: true,
  enableDragAndDrop: false,
};

export default CollectionItemCard;
